/* ============================================================
   ADMIN → USERS → EDIT: rekod claim ciri percuma PRO Studio
   ============================================================
   Arahan user 2026-09-26: rekod claim dipapar dalam popup "Edit".
   BACA SAHAJA — claim hanya ditulis oleh Cloud Function
   `tuntutCiriPercuma`. UI admin = English (peraturan projek).
   Dibaca terus daripada `users/{uid}` semasa popup dibuka (admin
   dibenarkan oleh rules), supaya tiada medan baharu perlu disalin
   ke dalam baris jadual Users.
   ============================================================ */

import { useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';

import { db } from '../firebase';
import { CIRI, rekodCiri, statusCiri } from '../utils/ciriPercuma';

const LABEL = { [CIRI.SHORTCUT]: 'Shortcut /', [CIRI.CTA]: 'CTA Beg Kuning' };
const fmt = (d) => (d
    ? d.toLocaleString('en-GB', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', timeZone: 'Asia/Kuala_Lumpur' })
    : '');

export default function AdminRekodCiriPercuma({ uid }) {
    const [keadaan, setKeadaan] = useState({ uid: null, data: null, ralat: '' });

    useEffect(() => {
        if (!uid) return undefined;
        let batal = false;
        getDoc(doc(db, 'users', uid))
            .then((snap) => { if (!batal) setKeadaan({ uid, data: snap.data()?.ciriPercuma || null, ralat: '' }); })
            .catch((e) => { if (!batal) setKeadaan({ uid, data: null, ralat: e?.code || 'error' }); });
        return () => { batal = true; };
    }, [uid]);

    const sedia = keadaan.uid === uid;

    return (
        <div>
            <label className="text-xs font-bold text-slate-600 dark:text-slate-400 uppercase">PRO Studio — Free Access (until 30 Nov 2026)</label>
            <div className="mt-2 bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 divide-y divide-slate-200 dark:divide-slate-700">
                {!sedia ? (
                    <p className="px-3 py-2 text-xs text-slate-400">Loading…</p>
                ) : keadaan.ralat ? (
                    <p className="px-3 py-2 text-xs text-rose-500">Could not read record ({keadaan.ralat}).</p>
                ) : Object.values(CIRI).map((c) => {
                    const { dituntutPada, sehingga } = rekodCiri(keadaan.data, c);
                    const st = statusCiri(keadaan.data, c, false);
                    return (
                        <div key={c} className="flex items-center gap-2 px-3 py-2 text-xs">
                            <span className="font-bold text-slate-700 dark:text-slate-200 w-32 shrink-0">{LABEL[c]}</span>
                            {dituntutPada ? (
                                <span className="text-slate-600 dark:text-slate-300">
                                    Claimed {fmt(dituntutPada)} · until {fmt(sehingga)}
                                    {st === 'tamat' && <span className="ml-1 text-rose-500 font-bold">(expired)</span>}
                                </span>
                            ) : (
                                <span className="text-slate-400">Not claimed</span>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
